module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiii",
      "title": "iii"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "photo50"
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "Title Page: Understanding Postmodernism: A Christian Perspective: Stewart E. Kelly With James K. Dew Jr.",
      "src": "Images/tp_art.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ivpacademic.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IVP Academic Imprint",
      "src": "Images/IVPAcademic.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b7a082c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/02_titlepage.vue
// module id = 57
// module chunks = 0